import $ from 'jquery';

const findTooltipTriggeringElementsByContext = vm => {
    const context = vm.$el;

    //Tooltips should be explicitly marked as such
    let filter = '[data-toggle="tooltip"]';

    //Hack: when possible; limit our selection to only the current scope
    //Due to Vue's scopeId not being publicly available, take a peek at its privates
    //Assumed format: data-abc123...
    if(vm.$options._scopeId && /^data-.+/.test(vm.$options._scopeId)){
        filter += `[${vm.$options._scopeId}]`;
    }

    //Limit our search to the current component
    return $(context).find(filter);
}

const initializeTooltipsByContext = vm => {
    findTooltipTriggeringElementsByContext(vm).tooltip();
};

const initializeTooltips = {
    methods: {
        initializeTooltips: function(){
            initializeTooltipsByContext(this);
        }
    }
};

const autoInitializeTooltips = {
    //On mount we should have an element to work with
    mounted() {
        initializeTooltipsByContext(this);
    }
};

const cleanTooltips = {
    methods: {
        cleanTooltips: function() {
            document.querySelectorAll('.tooltip.show[role="tooltip"]')
                .forEach(e => e.remove());
            
            //$.AdminLTE.options.enableBSToppltip
            //Some tooltips are initialized by the global tooltip init provided by AdminLTE
            //since those tooltips are bound to the body element, they won't correspond to a tooltip('hide') call on specific elements
            findTooltipTriggeringElementsByContext(this)
                .tooltip('dispose');
        }
    }
};

export {
    autoInitializeTooltips,
    initializeTooltips,
    cleanTooltips
};

export default initializeTooltips;